import AxiosInstance from './config/Http'
import Config from './config/Constants'


export const emailToDirectorate= async (body:any) => AxiosInstance.post(`${Config.profile.emailToDirectorate}`,body)


